"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultJsonSerializer = void 0;
exports.defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify
};
